<template>
  <router-view></router-view>
</template>

<script setup>
// O tema (claro/escuro) é inicializado em main.js via initTheme().
// O tema escuro é exclusivo do Sys: para qualquer outro usuário (ou sem login)
// a tela fica no claro, mesmo que o navegador tenha "dark" salvo.
import { watchEffect } from "vue";
import { useUserStore } from "@/stores/useUserStore";
import { setForceLight } from "@/composables/useTheme";

const userStore = useUserStore();

watchEffect(() => {
  setForceLight(userStore.currentUser?.userName !== "Sys");
});
</script>
